//Shop Hilton Garden Inn
$(function() {
  $(function() {
    var mobile = false;
    var tablet = false;
    var desktop = false;

    function checkWidth() {
      var viewportWidth = window.viewportSize.getWidth();
      if (viewportWidth <= 550) {
        if (!mobile) {
          $('body').removeClass('tablet');
          $('nav#top').insertAfter('p.main-logo');
          $('div.shop-cart').insertAfter('nav#top');
          $('p.search').insertBefore('div.content-wrapper');
          //$('#pgHome ul#main-nav').appendTo('div.content');
          $('div.cart-handler.chat').insertAfter('div.product-content');
          $('p.price-block').prependTo('div.cart-handler.chat .inner-box');
          $('div.selections-wrap').insertAfter('p.price-block');
          $('p.share-icons').insertBefore('div.item-copy');
          $('div.product-content .flexslider ul.slides li a').contents().unwrap();
          $('body#pgHome div.top-promo').insertAfter('div.header-wrapper');
      $('div.hdr-promo').insertAfter('div.top-promo');

        }
        mobile = true;
        desktop = false;
        tablet = false;
      } else if (viewportWidth >= 551 && viewportWidth <= 960) {
        if (!tablet) {
          $('body').addClass('tablet');
          $('nav#top').prependTo('div.topnav div.menu-wrap');
          $('div.shop-cart').appendTo('div.topnav div.menu-wrap');
          $('p.search').insertBefore('div.content-wrapper');
          //$('#pgHome ul#main-nav').insertAfter('h3#btn-main-nav');
          $('div.cart-handler.chat').insertAfter('div.cart-handler.main');
          $('p.price-block').prependTo('div.cart-handler.main .inner-box');
          $('div.selections-wrap').appendTo('div.cart-handler.main .inner-box');
          $('p.share-icons').appendTo('div.product-content');
          $('body#pgHome div.top-promo').insertAfter('div.topnav-wrapper');
      $('div.hdr-promo').insertAfter('div.top-promo');

        }
        mobile = false;
        desktop = false;
        tablet = true;
      } else {
        if (!desktop) {
          $('body').removeClass('tablet');
          $('nav#top').prependTo('div.topnav div.menu-wrap');
          $('div.shop-cart').appendTo('div.topnav div.menu-wrap');
          $('p.search').insertAfter('p.main-logo');
          //$('#pgHome ul#main-nav').insertBefore('div.shop-cart');
          $('div.cart-handler.chat').insertAfter('div.cart-handler.main');
          $('p.price-block').prependTo('div.cart-handler.main .inner-box');
          $('div.selections-wrap').appendTo('div.cart-handler.main .inner-box');
          $('p.share-icons').appendTo('div.product-content');
          $('body#pgHome div.top-promo').insertAfter('div.topnav-wrapper');
      $('div.hdr-promo').insertBefore('div.header-wrapper');

        }
        mobile = false;
        desktop = true;
        tablet = false;
      }
    }
    checkWidth();
    $(window).on('resize', checkWidth);
  });

  //Left-Nav
  $(function() {
    $(".btn-left-nav a").on("click", function(e) {
      e.preventDefault();
      var hrefval = $(this).attr("href");
      if (hrefval == "#grid-6lt") {
        var distance = $('#grid-2sl').css('left');
        if (distance == "auto" || distance == "0px") {
          $(this).addClass("open");
          openSidepage();
        } else {
          closeSidepage();
        }
      }
    });
    $("#closebtn").on("click", function(e) {
      e.preventDefault();
      closeSidepage();
    });

    function openSidepage() {
      $('#grid-2sl').animate({
        left: '250px'
      }, 400, 'easeOutBack');
    }

    function closeSidepage() {
      $(".btn-left-nav a").removeClass("open");
      $('#grid-2sl').animate({
        left: '0px'
      }, 400, 'easeOutQuint');
    }
    $("#btn-main-nav").on('click', function() {
      if ($("#grid-6lt").is(":visible")) {
        closeSidepage()
      }
      $(this).toggleClass('inactive activated').next().toggle();
    });

  });


  //Product Page Item description collapse and tabs
  $(function() {
    $('#tabs > div').hide();
    $('#tabs > div:first').show();
    $('#tabs > ul.tab-links li:first').addClass('active');
    $('#tabs > ul.tab-links li a').on('click', function() {
      $('#tabs > ul.tab-links li').attr('class', '');
      $(this).parent().attr('class', 'active');
      var currentTab = $(this).attr('href');
      $('#tabs > div').hide();
      $(currentTab).show();
      return false;
    });
  });
  //Equalize Columns
  $(function() {
    var equalheight = function(container) {
      var currentTallest = 0,
        currentRowStart = 0,
        rowDivs = new Array(),
        $el, topPostion = 0,
        currentDiv = 0;
      $(container).each(function() {
        $el = $(this);
        $($el).height('auto')
        topPostion = $el.position().top;

        if (currentRowStart != topPostion) {
          for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
            rowDivs[currentDiv].height(currentTallest);
          }
          rowDivs.length = 0;
          currentRowStart = topPostion;
          currentTallest = $el.height();
          rowDivs.push($el);
        } else {
          rowDivs.push($el);
          currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
        }
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].height(currentTallest);
        }
      });
    }
    $(function() {
      equalheight('.hero-col');
      equalheight('body:not(.pgCheckout) .delivery li a');
    });
    $(window).on('resize', function() {
      equalheight('.hero-col');
      equalheight('body:not(.pgCheckout) .delivery li a');
    });
  });
  // For selects
  $(function() {
    var isWebkit = 'WebkitAppearance' in document.documentElement.style;
    if (isWebkit) {
      $("html").addClass("isWebkit");
    }
  });
  // Product Page Slider
  $(function() {
    $('.item-image').flexslider({
      animation: "slide",
      animationLoop: false
    });
  });
  /* Promo Headers - */
  (function($) {
    $.fn.flowtype = function(options) {
      var settings = $.extend({
          maximum: 9999,
          minimum: 1,
          maxFont: 9999,
          minFont: 1,
          fontRatio: 35
        }, options),
        changes = function(el) {
          var $el = $(el),
            elw = $el.width(),
            width = elw > settings.maximum ? settings.maximum : elw < settings.minimum ? settings.minimum : elw,
            fontBase = width / settings.fontRatio,
            fontSize = fontBase > settings.maxFont ? settings.maxFont : fontBase < settings.minFont ? settings.minFont : fontBase;
          $el.css('font-size', fontSize + 'px');
        };

      return this.each(function() {
        var that = this;
        $(window).on('resize', function() {
          changes(that);
        });
        changes(this);
      });
    };
  }(jQuery));
  $('.top-promo').flowtype({
    minimum: 480,
    maximum: 1090,
    minFont: 12,
    maxFont: 32,
    fontRatio: 32
  }); /*
  $('.top-promo a').flowtype({
    minimum: 480,
    maximum: 1090,
    minFont: 12,
    maxFont: 32,
    fontRatio: 32
  }); */
  $('.top-promo.automate p').flowtype({
    minimum: 480,
    maximum: 1090,
    minFont: 12,
    maxFont: 30,
    fontRatio: 33
  });

});